import "../css/navigation.css";
import HireMe from "../images/hireme.webp";
import AboutMe from "../images/aboutme.webp";
import Projects from "../images/projects.webp";
export default function Navigation(){
    return (
        <>
<div id="navigation">
   <div> <img src={HireMe} alt="Hire Me" onClick={()=>{window.open("/hireme","_self")}}/></div>
   <div> <img src={AboutMe} alt="About Me"  onClick={()=>{window.open("/about","_self")}}/></div>
  <div>  <img src={Projects} alt="Projects"  onClick={()=>{window.open("/project","_self")}}/></div>
</div>
<div id="navtext">
    <p  onClick={()=>{window.open("/hireme","_self")}}>Hire Me</p>
    <p  onClick={()=>{window.open("/about","_self")}}>About Me</p>
    <p  onClick={()=>{window.open("/project","_self")}}>Projects</p>
</div>
</>
    );
}